<template>
  <AlertComponent
    v-for="(alert, index) in filteredAlerts"
    :key="index"
    :type="alert.type"
    :details="alert.details || {}"
    :index="alert.index"
    :dismissible="true"
    :auto-dismiss="alert.autoDismiss"
  />
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';
import AlertComponent from '@/components/AlertComponent.vue';
import { mapStores } from 'pinia';
import type { IAlertDetails } from '@/stores/global/globalStore.model.ts';

const componentOptions: ComponentOptions = {
  name: 'AlertsComponent',
  props: {
    context: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    AlertComponent,
  },
  computed: {
    ...mapStores(useGlobalStore),
    filteredAlerts() {
      return this.context
        ? this.globalStore.alerts.filter((alert: IAlertDetails) => alert.context === this.context)
        : this.globalStore.alerts;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss"></style>
